import { css, html, LitElement } from "lit";

import { fetchLeaderboard } from "../common/api";
import { setTitle, trackPage } from "../common/client";
import { getLevel } from "../common/exp";
import { clipPlayerName, getPlayerNameColor } from "../common/utils";
import { websiteStyles } from "../styles/website";

export class LeaderboardPage extends LitElement {
  constructor() {
    super();

    /** @type {Array<LeaderboardData>} */
    this.leaderboard = [];

    this.timer = null;

    this.loadData();
  }

  async loadData() {
    this.leaderboard = (await fetchLeaderboard()) || [];
  }

  static properties = {
    leaderboard: { type: Array },
  };

  static styles = [
    websiteStyles,
    css`
      :host {
        display: block;
        width: 100vw;
        height: 100vh;
        background: #FFF;
        color: white;
        padding-top: 70px;
        background-size: cover;
        background-position-y: center;
      }

      row {
        cursor: pointer;
      }

      small {
        font-size: 12px;
        color: #aaa;
      }

      @media (max-width: 768px) {
        .row {
          .cell.stats {
            width: 100%;
          }
        }
      }
    `,
  ];

  connectedCallback() {
    super.connectedCallback();

    trackPage();
    setTitle("Leaderboard");
  }

  firstUpdated() {
    this.timer = setInterval(async () => {
      await this.loadData();
    }, 30000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  render() {
    return html`
      <navbar-component></navbar-component>
      <section>
        <div class="content">
          ${this.leaderboard?.map((lb, index) => {
            return html` <div class="row" @click=${() => {
              if (lb.playerId) {
                window.location.href = `./user/${lb.playerId}`;
              }
            }}>
              <div class="cell">
                <span
                  class="heading-uppercase"
                  style="font-size: 12px;display:block;"
                  >Rank</span
                >
                <span>${lb.rank}</span>
              </div>
              <div class="cell" style="margin-right: 10px;">
                <img
                  src=${lb.avatar ? `${lb.avatar}` : `./images/logo.jpeg`}
                  title="${lb.name}"
                  class="player-icon"
                />
              </div>
              <div class="cell" style="min-width:100px;line-height: 15px;">
                <span
                  class="heading-uppercase"
                  style="font-size: 24px;color:${getPlayerNameColor(lb.points || 0)};"
                  >${clipPlayerName(lb.name)}</span
                ><br /><small>Level ${getLevel(lb.points || 0)}</small>
              </div>
              <div class="cell stats">
                <span class="heading-uppercase" style="font-size: 30px;"
                  >${Math.round(lb.points || 0).toLocaleString()}</span
                >
              </div>
            </div>${index === 0 && lb.rank !== 1 ? html`<br><br>` : ""}`;
          })}
        </div>
      </section>
    `;
  }
}

customElements.define("leaderboard-page", LeaderboardPage);
